import { services } from './services';

export const serviceOptions = [
  ...services.map((service) => ({ value: service.id as string, label: service.title })),
  { value: 'equipment', label: 'Plant & equipment for a project' },
  { value: 'other', label: 'Other / not sure yet' },
];

export const budgetOptions = [
  'Under P1 million',
  'P1 – 5 million',
  'P5 – 20 million',
  'P20 – 50 million',
  'Over P50 million',
  'Prefer not to say',
];

export const timelineOptions = [
  'As soon as possible',
  'Within 3 months',
  '3 – 6 months',
  '6 – 12 months',
  'More than 12 months',
  'Not yet known',
];
